<template>
  <ImageHeader :imageSource="require('../assets/leeb-images3/pic1.jpg')" :headerTitle="'Zahlungseingänge'">
    <v-card elevation="0">
      <v-card-title>Zahlungen</v-card-title>
      <v-card-text>
        <v-data-table
          :headers="paymentDataHeaders"
          :items="paymentDataEntries"
          :loading="!paymentDataLoaded"
          :hide-default-footer="true"
          :hide-default-header="false"
          :item-key="'AbasEntryId'"
        >
          <template v-slot:[`item.BookingDate`]="{ item }">
            <span>{{ $d(Date.parse(item.BookingDate), 'short') }}</span>
          </template>
          <template v-slot:[`item.Amount`]="{ item }">
            <span>{{ $n(item.Amount, 'currency', 'de-DE') }}</span>
          </template>
          <template slot="body.append" v-if="paymentDataLoaded">
            <tr><td></td><th>Summe</th></tr>
            <tr>
              <td><b>Total</b></td>
              <td><b>{{ $n(getTotalAmount(), 'currency', 'de-DE') }}</b></td>
            </tr>
            <tr>
              <td><b>Kundensaldo</b></td>
              <td><b>{{ $n(balanceDataValue, 'currency', 'de-DE') }}</b></td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </ImageHeader>
</template>

<script>
import ImageHeader from '../components/ImageHeader.vue'
import dataAssembler from '../plugins/dataAssembler';

export default {
  name: 'Payments',
  components: {
    ImageHeader
  },
  data: () => ({
    paymentDataEntries: [],
    paymentDataLoaded: false,
    paymentDataHeaders: [
      {text: 'Buchungsdatum', value: 'BookingDate', sortable: false},
      {text: 'Gezahlter Betrag', value: 'Amount', sortable: false}
    ],
    balanceDataValue: 0,
    balanceDataLoaded: false,
  }),
  methods: {
    getTotalAmount() {
      let result = 0;
      this.paymentDataEntries.forEach(x => result += x.Amount);
      return result;
    },
    loadAccountHistoryData() {
      this.$http(
        dataAssembler.contructPaymentsAxiosQuery(this.$store.getters.customerNumber(), this.$store.getters.token())
      ).then((response) => {
        this.paymentDataEntries = response.data;
        this.paymentDataLoaded = true;
      }).catch((error) => {
        console.error(error);
        this.$snackbar('Ein Fehler ist aufgetreten!', 'red darken-1');
      });
    },
    loadCustomerBalance() {
      this.balanceDataLoaded = false;
      this.balanceDataValue = 0;
      this.$http(
        dataAssembler.constructProfileBalanceAxiosQuery(this.$store.getters.token(), this.$store.getters.customerNumber())
      ).then((response) => {
        this.balanceDataValue = response.data;
        this.balanceDataLoaded = true;
      }).catch((error) => {
        console.error(error);
        this.$snackbar('Ein Fehler ist aufgetreten!', 'red darken-1');
      });
    },
  },
  created() {
    this.loadAccountHistoryData();
    this.loadCustomerBalance();
  }
};
</script>
